import React from "react";
import Popover from "@material-ui/core/Popover";
import MoreVertIconRounded from "@material-ui/icons/MoreVertRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { Refresh, FileCopy, GetApp, Visibility } from "@material-ui/icons";

import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, IconButton } from "@material-ui/core";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  renameButton: {
    textTransform: "none",
  },
  editIcon: {
    margin: "0.1rem",
  },
  deleteIcon: {
    margin: "0.1rem",
  },
  fileCopy: {
    margin: "0.1rem",
  },
  getApp: {
    margin: "0.1rem",
  },

  renameFolder: {
    textTransform: "none",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
  },
}));

export default function versionSelectorOptions(props) {
  let [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  function handleToggleLock() {
    if (!props.menuLayout || !props.selectedVersion || !props.selectedVersion._id) return;
    if (_.get(props, "selectedBase.playEngineInstance", false)) return;
    if (props.userPermissions["editContent"] === false) {
      props.createSnackbar("You are not authorized to update, contact your administrator.", "warning", false);
      return;
    }

    const nextLocked = !props.selectedVersion.isLocked;
    fetch(getServerUri("version/setLocked"), {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        versionID: String(props.selectedVersion._id),
        locked: String(nextLocked),
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          const updatedVersion = { ...props.selectedVersion, isLocked: nextLocked };
          if (props.setSelectedVersion) props.setSelectedVersion(updatedVersion);
          if (props.setVersions && props.versions) {
            props.setVersions(
              props.versions.map((version) =>
                String(version._id) === String(props.selectedVersion._id)
                  ? { ...version, isLocked: nextLocked }
                  : version
              )
            );
          }
          if (props.fetchVersions && props.selectedBase) {
            props.fetchVersions(props.selectedBase._id, localStorage.getItem("user.companyID"));
          }
          props.createSnackbar(
            nextLocked ? "Version locked." : "Version unlocked.",
            "success",
            false
          );
          setAnchorEl(null);
        } else if (response.status === 401) {
          props.createSnackbar("You are not authorized to update, contact your administrator.", "warning", false);
        } else {
          response.text().then((text) => {
            props.createSnackbar(`Could not update lock state: ${text}`, "warning", false);
          });
        }
      })
      .catch(() => {
        props.createSnackbar("Could not update lock state.", "warning", false);
      });
  }

  function ButtonVisibilty() {
    if (props.userID) {
      if (props.userID == "6332cfdaf6904200291ca8c3") {
        return "flex";
      } else {
        return "none";
      }
    }
  }

  return (
    <div id="threeDot_button">
      <IconButton id="versionSelectorOptions_button" component="span" onClick={handleClick}>
        <MoreVertIconRounded
          aria-owns={open ? "simple-popper" : undefined}
          aria-haspopup="true"
          variant="contained"
        ></MoreVertIconRounded>
      </IconButton>
      <Popover
        id="simplePopper_versionSelector"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {props.menuLayout ? (
          <Button
            id="renameVersion_button"
            className={classes.renameButton}
            style={{
              width: "150px",
              justifyContent: "flex-start",
            }}
            startIcon={<EditIcon className={classes.editIcon} />}
            onClick={() => {
              if (props.userPermissions["editContent"] === false) {
                props.createSnackbar("You are not authorized to update, contact your administrator.", "warning", false);
                return;
              }
              props.setIsRenameVersionDialogOpen(true);
              setAnchorEl(false);
            }}
          >
            Rename Version
          </Button>
        ) : (
          <Button
            id="renameFolder_button"
            style={{
              width: "150px",
              justifyContent: "flex-start",
            }}
            className={classes.renameFolder}
            startIcon={<EditIcon className={classes.editIcon} />}
            onClick={() => {
              if (props.userPermissions["editContent"] === false) {
                props.createSnackbar("You are not authorized to update, contact your administrator.", "warning", false);
                return;
              }

              props.setIsRenameFolderDialogOpen(true);
              setAnchorEl(false);
            }}
          >
            Rename Folder
          </Button>
        )}

        {props.menuLayout && !_.get(props, "selectedBase.playEngineInstance", false) ? (
          <Button
            id="lockVersion_button"
            className={classes.renameFolder}
            style={{
              width: "150px",
              justifyContent: "flex-start",
            }}
            startIcon={
              props.selectedVersion && props.selectedVersion.isLocked ? (
                <LockOpenIcon className={classes.editIcon} />
              ) : (
                <LockIcon className={classes.editIcon} />
              )
            }
            onClick={handleToggleLock}
          >
            {props.selectedVersion && props.selectedVersion.isLocked ? "Unlock Version" : "Lock Version"}
          </Button>
        ) : null}

        {props.menuLayout ? (
          <Button
            id="duplicateVersion_button"
            className={classes.renameFolder}
            startIcon={<FileCopy className={classes.fileCopy} />}
            onClick={async () => {
              if (props.userPermissions["createVersion"] !== true) {
                props.createSnackbar("You are not authorized to create versions, contact your administrator.", "warning", false);
                return;
              }
              props.setIsDuplicateDialogOpen(true);
              setAnchorEl(false);
            }}
          >
            Duplicate Version
          </Button>
        ) : (
          <Button
            id="duplicateFolder_button"
            className={classes.renameFolder}
            style={{
              width: "150px",
              justifyContent: "flex-start",
            }}
            startIcon={<FileCopy className={classes.fileCopy} />}
            onClick={async () => {
              if (props.userPermissions["createVersion"] !== true) {
                props.createSnackbar("You are not authorized to create versions, contact your administrator.", "warning", false);
                return;
              }
              props.setIsFolderDialogOpen(true);
              setAnchorEl(false);
            }}
          >
            Duplicate Folder
          </Button>
        )}

        <Button
          className={classes.renameFolder}
          id="delete_button"
          style={{
            width: "150px",
            justifyContent: "flex-start",
          }}
          startIcon={<DeleteIcon className={classes.deleteIcon} />}
          onClick={() => {
            if (props.userPermissions["deleteContent"] === false) {
              props.createSnackbar("You are not authorized to delete, contact your administrator.", "warning", false);
              return;
            }
            props.setIsDeleteDialogOpen(true);
            setAnchorEl(false);
          }}
        >
          Delete
        </Button>
        <Button
          className={classes.renameFolder}
          id="deleteAll_button"
          style={{
            width: "150px",
            justifyContent: "flex-start",
            display: ButtonVisibilty(),
          }}
          startIcon={<DeleteIcon className={classes.deleteIcon} />}
          onClick={() => {
            if (props.userPermissions["deleteContent"] === false) {
              props.createSnackbar("You are not authorized to delete, contact your administrator.", "warning", false);
              return;
            }
            props.setIsDeleteAllDialogOpen(true);
            setAnchorEl(false);
          }}
        >
          Delete All
        </Button>
        {/* <Button
                    className={classes.renameFolder}
                    startIcon={<GetApp className={classes.getApp} />}
                    onClick={() => {
                        if (props.userPermissions["deleteContent"] === false) {
                            props.createSnackbar("You are not authorized to delete, contact your administrator.", "warning", false);
                            return;
                        }
                        props.setIsDownloadDialogOpen(true);
                    }}>
                    Download Version
                </Button> */}
      </Popover>
    </div>
  );
}
